<template>
  <guest-layout background-class="bg-white" color-scheme="light" poper-absolute="true">

    <main>
      <!-- Hero section -->
<!--      <div class="relative isolate overflow-hidden pb-16 pt-14 sm:pb-20">-->
<!--&lt;!&ndash;        <img :src="asset('img/features/earth-3866609_1920.png')" alt="" class="absolute inset-0 -z-10 h-full w-full object-cover" />&ndash;&gt;-->
<!--        <div class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">-->
<!--          <div class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />-->
<!--        </div>-->
<!--        <div class="mx-auto max-w-7xl px-6 lg:px-8">-->
<!--          <div class="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">-->
<!--            <div class="hidden sm:mb-8 sm:flex sm:justify-center">-->
<!--              <div class="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-400 ring-1 ring-gray/10 hover:ring-gray/20">-->
<!--                Announcing our next round of funding. <a href="#" class="font-semibold text-gray-900white"><span class="absolute inset-0" aria-hidden="true" />Read more <span aria-hidden="true">&rarr;</span></a>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="text-center">-->
<!--              <h1 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">Deploy to the cloud with confidence</h1>-->
<!--              <p class="mt-6 text-lg leading-8 text-gray-300">Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat fugiat aliqua.</p>-->
<!--              <div class="mt-10 flex items-center justify-center gap-x-6">-->
<!--                <a href="#" class="rounded-md bg-primary-500 px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-400">Get started</a>-->
<!--                <a href="#" class="text-sm font-semibold leading-6 text-gray-900">Live demo <span aria-hidden="true">→</span></a>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->


<!--      <div class="relative pt-14">-->
<!--        <div class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">-->
<!--          <div class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />-->
<!--        </div>-->
<!--        <div class="py-24 sm:py-32">-->
<!--          <div class="mx-auto max-w-7xl px-6 lg:px-8">-->
<!--            <div class="mx-auto max-w-2xl text-center">-->
<!--              <h1 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">Deploy to the cloud with confidence</h1>-->
<!--              <p class="mt-6 text-lg leading-8 text-gray-600">Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat fugiat aliqua.</p>-->
<!--              <div class="mt-10 flex items-center justify-center gap-x-6">-->
<!--                <a href="#" class="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">Get started</a>-->
<!--                <a href="#" class="text-sm font-semibold leading-6 text-gray-900">Learn more <span aria-hidden="true">→</span></a>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="mt-16 flow-root sm:mt-24">-->
<!--              <div class="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">-->
<!--                <img src="https://tailwindui.com/img/component-images/project-app-screenshot.png" alt="App screenshot" width="2432" height="1442" class="rounded-md shadow-2xl ring-1 ring-gray-900/10" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]" aria-hidden="true">-->
<!--          <div class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />-->
<!--        </div>-->

<!--          &lt;!&ndash; Logo cloud &ndash;&gt;-->
<!--          <div class="mx-auto grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">-->
<!--            <img class="col-span-2 max-h-12 w-full object-contain lg:col-span-1" src="https://tailwindui.com/img/logos/158x48/transistor-logo-white.svg" alt="Transistor" width="158" height="48" />-->
<!--            <img class="col-span-2 max-h-12 w-full object-contain lg:col-span-1" src="https://tailwindui.com/img/logos/158x48/reform-logo-white.svg" alt="Reform" width="158" height="48" />-->
<!--            <img class="col-span-2 max-h-12 w-full object-contain lg:col-span-1" src="https://tailwindui.com/img/logos/158x48/tuple-logo-white.svg" alt="Tuple" width="158" height="48" />-->
<!--            <img class="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1" src="https://tailwindui.com/img/logos/158x48/savvycal-logo-white.svg" alt="SavvyCal" width="158" height="48" />-->
<!--            <img class="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1" src="https://tailwindui.com/img/logos/158x48/statamic-logo-white.svg" alt="Statamic" width="158" height="48" />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]" aria-hidden="true">-->
<!--          <div class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />-->
<!--        </div>-->
<!--      </div>-->

      <!-- Feature section -->
      <div class="py-24 sm:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div v-motion-pop class="mx-auto max-w-2xl sm:text-center">
            <h2 class="text-base font-semibold leading-7 text-primary-600">{{ __('Everything you need') }}</h2>
            <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ __('Building Customer Trust Made Simple') }}</p>
            <p class="mt-6 text-lg leading-8 text-gray-600">{{ __('Unlock the power of trust and elevate your business with these simple yet effective strategies to build strong and lasting relationships with your customers.') }}</p>
          </div>
        </div>
        <div class="relative overflow-hidden pt-16">
          <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <img v-motion-pop :src="asset('build/statuspage-inception.png')" draggable="false" alt="App screenshot" class="mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10" width="2432" height="1442" />
            <div class="relative" aria-hidden="true">
              <div class="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white pt-[7%]" />
            </div>
          </div>
        </div>
        <div class="mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8">
          <dl class="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base leading-7 text-gray-600 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16">
            <div
                v-for="(feature, iX) in features"
                v-motion
                :initial="{ x: -100, opacity: 0 }"
                :enter="{ x: 0, opacity: 1 }"
                :delay="(iX+1)*150"
                :key="iX"
                class="relative pl-9"
            >
              <dt class="inline font-semibold text-gray-900">
                <div class="absolute -left-4 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                  <component :is="feature.icon" class="h-6 w-6" aria-hidden="true" />
                </div>
<!--                <component :is="feature.icon" class="absolute left-1 top-1 h-5 w-5 text-primary-600" aria-hidden="true" />-->
                {{ __(feature.name) }}
              </dt>
              {{ ' ' }}
              <dd class="inline">{{ __(feature.description) }}</dd>
            </div>
          </dl>
        </div>
      </div>

      <hr class="divider"/>

      <!-- Pricing section -->
      <package-pricing-boxes/>

      <hr class="divider"/>

      <!-- Product Features -->
      <feature-preview-box/>

      <hr class="divider"/>

      <!-- Testimonials -->
      <testimonials :background-class="'bg-white'"/>

      <!-- FAQ section -->
<!--      <div class="mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8">-->
<!--        <div class="mx-auto max-w-4xl divide-y divide-gray-900/10">-->
<!--          <h2 class="text-2xl font-bold leading-10 tracking-tight text-gray-900">{{ __('Frequently asked questions') }}</h2>-->
<!--          <dl class="mt-10 space-y-6 divide-y divide-gray-900/10">-->
<!--            <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">-->
<!--              <dt>-->
<!--                <DisclosureButton class="flex w-full items-start justify-between text-left text-gray-900">-->
<!--                  <span class="text-base font-semibold leading-7">{{ __(faq.question) }}</span>-->
<!--                  <span class="ml-6 flex h-7 items-center">-->
<!--                    <PlusSmallIcon v-if="!open" class="h-6 w-6" aria-hidden="true" />-->
<!--                    <MinusSmallIcon v-else class="h-6 w-6" aria-hidden="true" />-->
<!--                  </span>-->
<!--                </DisclosureButton>-->
<!--              </dt>-->
<!--              <DisclosurePanel as="dd" class="mt-2 pr-12">-->
<!--                <p class="text-base leading-7 text-gray-600">{{ __(faq.answer) }}</p>-->
<!--              </DisclosurePanel>-->
<!--            </Disclosure>-->
<!--          </dl>-->
<!--        </div>-->
<!--      </div>-->
    </main>

  </guest-layout>
</template>

<script setup>
import { ref } from 'vue'
import { Dialog, DialogPanel, Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { PresentationChartBarIcon as Bars3Icon, MinusSmIcon as MinusSmallIcon, PlusSmIcon as PlusSmallIcon, XIcon as XMarkIcon } from '@heroicons/vue/outline'
import {
  ArrowUpIcon as ArrowPathIcon,
  CheckIcon,
  CloudUploadIcon as CloudArrowUpIcon,
  CogIcon as Cog6ToothIcon,
  FingerPrintIcon,
  LockClosedIcon,
  ServerIcon,
  ChartBarIcon,
} from '@heroicons/vue/solid'
import GuestLayout from "@/Layouts/GuestLayout";
import PackagePricingBoxes from "@/Pages/Sites/FeatureSections/PackagePricingBoxes";
import FeaturePreviewBox from "@/Pages/Sites/FeatureSections/FeaturePreviewBox";
import Testimonials from "@/Pages/Sites/FeatureSections/Testimonials";

const features = [
  {
    name: 'Docker-Ready',
    description: 'Docker-Ready with LIVCK. Our system can be easily deployed as a Docker stack, providing you with a seamless and flexible deployment option.', // __('Docker-Ready with LIVCK. Our system can be easily deployed as a Docker stack, providing you with a seamless and flexible deployment option.')
    icon: ServerIcon,
  },
  {
    name: 'Automatic Updates', // __('Automatic Updates')
    description: 'Stay up-to-date with automatic updates from LIVCK. We ensure that you always have the latest version without any hassle, as our system automatically handles the updates for you.', // __('Stay up-to-date with automatic updates from LIVCK. We ensure that you always have the latest version without any hassle, as our system automatically handles the updates for you.')
    icon: CloudArrowUpIcon,
  },
  {
    name: 'SSL Certificates', // __('SSL Certificates')
    description: 'Experience a secure connection with LIVCK through our SSL certificate with automatic renewal. We take care of renewing the certificate for you, ensuring that your data is always protected.', // __('Experience a secure connection with LIVCK through our SSL certificate with automatic renewal. We take care of renewing the certificate for you, ensuring that your data is always protected.')
    icon: ArrowPathIcon,
  },
  {
    name: 'Efficient Performance Testing', // __('Efficient Performance Testing')
    description: 'LIVCK provides you with high-performance and resource-efficient scanning. Our systems ensure fast and thorough scanning of your systems without placing high demands on resources.', // __('LIVCK provides you with high-performance and resource-efficient scanning. Our systems ensure fast and thorough scanning of your systems without placing high demands on resources.')
    icon: ChartBarIcon,
  },
  {
    name: 'REST API',
    description: 'Seamlessly integrate LIVCK into other systems with our fast and efficient REST API. You can easily exchange data and leverage the extensive capabilities of our API.', // __('Seamlessly integrate LIVCK into other systems with our fast and efficient REST API. You can easily exchange data and leverage the extensive capabilities of our API.')
    icon: Cog6ToothIcon,
  },
  {
    name: 'Security',
    description: 'Protect your data with LIVCK and take advantage of our included access control for the status page. Our special feature allows you to prevent unauthorized access and restrict access to the system monitoring page to authorized employees only. Trust in the reliable security of LIVCK at no additional cost.',
    icon: FingerPrintIcon,
  },
];
const tiers = [
  {
    name: 'Smart',
    id: 'tier-hobby',
    href: '#',
    priceMonthly: '4,99 €',
    description: "The perfect plan if you're just getting started with our product.", // __("The perfect plan if you're just getting started with our product.")
    features: [
      '10 Monitors',
      '5 Categories',
      '50 Announcements',
      // '50 Newsletter Subscribers',
      '2 Team Members',
    ],
    featured: false,
  },
  {
    name: 'Extended',
    id: 'tier-enterprise',
    href: '#',
    priceMonthly: '39,99 €',
    description: 'Dedicated support and infrastructure for your company.', // __('Dedicated support and infrastructure for your company.')
    features: [
      'Unlimited Monitors',
      'Unlimited Categories',
      'Unlimited Announcements',
      'Unlimited Newsletter Subscribers',
      'Unlimited Team Members',
    ],
    featured: true,
  },
]
const faqs = [
  {
    question: "What is a self-hosted status page?",
    answer: "A self-hosted status page is a dedicated webpage that provides real-time information about the status and availability of your systems, services, or applications. Unlike using a third-party service, a self-hosted status page is hosted on your own infrastructure, giving you complete control over its setup, customization, and data management.",
  },
  {
    question: "Why should I choose a self-hosted status page?",
    answer: "Opting for a self-hosted status page offers several benefits. Firstly, you have full control over the page's design and branding, ensuring it aligns with your company's visual identity. Additionally, hosting the status page on your own infrastructure gives you greater privacy and security control over your data. You can also customize the page's features and integrations to suit your specific monitoring and reporting needs.",
  },
  {
    question: "What are the system requirements for hosting a self-hosted status page?",
    answer: "Hosting a self-hosted status page typically requires a web server or cloud infrastructure capable of running web applications. You will need a domain or subdomain for hosting the page, along with an SSL certificate for secure communication. Additionally, depending on the chosen software or framework, specific software dependencies or database requirements may need to be met.",
  },
  {
    question: "Can I integrate a self-hosted status page with other monitoring tools?",
    answer: "Yes, most self-hosted status page solutions offer integration capabilities with various monitoring tools and services. This allows you to aggregate data from multiple sources and provide a comprehensive view of your system's health. Common integration options include alerting systems, incident management platforms, and performance monitoring tools.",
  },
  {
    question: "Is technical expertise required to set up and maintain a self-hosted status page?",
    answer: "While setting up and maintaining a self-hosted status page may require some technical knowledge, many solutions offer user-friendly interfaces and documentation to assist you throughout the process. Additionally, community support and online resources are often available to help troubleshoot any issues or provide guidance on customization and advanced configurations.",
  },
  {
    question: "Can I customize the appearance and layout of my self-hosted status page?",
    answer: "Absolutely! With a self-hosted status page, you have complete control over its appearance and layout. You can customize the colors, logo, branding elements, and overall design to match your company's visual identity. Additionally, many solutions provide templates and styling options to simplify the customization process.",
  },
];
</script>